const routes = {
  productSelectionPage: '/order-found',
  findOrdersPage: '/find-orders',
  recoveredOrdersPage: '/recovered-orders',
  deliveryMethodsPage: '/delivery-methods',
  summaryPage: '/summary',
  processCompletedPage: '/process-completed',
  verifyEmailPage: '/verify-email',
  evaluationOptOutPage: '/opt-out',
  login: '/login',
  refundSelectionPage: '/refund-selection',
  exchangeAddressPage: '/exchange-address',
  productDetailPage: '/product-detail/:id',
  notFoundPage: '/error/not-found-page',
  successPage: '/success/:orderId/return/:returnId',
}

export default routes
